export default 'fonts/841f2c41fa5a3cec689737048e8280ee.woff2';